/**
 * Shared Sabil Outstanding broadcast constants.
 * Tenant allowlist must stay in sync with API `SABIL_OUTSTANDING_BROADCAST_ENABLED_TENANT_IDS`.
 */

import { isTenantInOutstandingBroadcastAllowlist } from "./outstanding-broadcast-tenant-gate";

export const DEFAULT_SABIL_OUTSTANDING_TEMPLATE_NAME = "sabil_chula_outstanding_reminder";
export const SABIL_ESTABLISHMENT_OUTSTANDING_TEMPLATE_NAME =
  "sabil_establishment_outstanding_reminder";

export const SABIL_OUTSTANDING_NOTIFY_HOUSEHOLD_AND_FAMILY = "household_and_family";
export const SABIL_OUTSTANDING_NOTIFY_HOUSEHOLD_ONLY = "household_only";
export const DEFAULT_SABIL_OUTSTANDING_MIN_PERCENT = 1;

export const SABIL_OUTSTANDING_BROADCAST_ENABLED_TENANT_IDS: ReadonlySet<string> = new Set([
  "FP1",
  "JP1",
]);

/** True when Sabil Outstanding mode should be shown / used for this tenant. */
export function isSabilOutstandingBroadcastEnabledForTenant(
  tenantId: string | null | undefined
): boolean {
  return isTenantInOutstandingBroadcastAllowlist(
    tenantId,
    SABIL_OUTSTANDING_BROADCAST_ENABLED_TENANT_IDS
  );
}
